export default {"allSportsMenu":"nW2Z-","content":"KuNVA","header":"j-Mp7","open":"FPwfF","fullHeight":"NEIXH"};